
import { defineComponent } from "vue";
import Dropdown from "@/components/Dropdown.vue";
import SVG from "./Svg.vue";
import { svgNames } from "@/constants/globalConstants";

export default defineComponent({
    name: "AlgoNavBar",
    components: { Dropdown, SVG },
    props: {
        algorithmsList: {
            type: Array,
            required: true,
        },
        buttonsList: {
            type: Array,
            required: true,
        },
        selectedAlgo: {
            type: String,
            required: true,
        },
        algoSpeed: {
            type: Number,
            required: false,
        },
        cellSize: {
            type: Number,
            required: false,
        },
        arraySize: {
            type: Number,
            required: false,
        },
        showMazeDropdown: {
            type: Boolean,
            default: false,
        },
        mazeGenAlgorithmsList: {
            type: Array,
            required: false,
        },
    },
    data() {
        return {
            svgNames,
            algoDropdownVisible: false,
            speedDropdownVisible: false,
            mazeDropdownVisible: false,
            cellSizeDropdownVisible: false,
            arraySizeDropdownVisible: false,
            normalStyle: {
                color: "#ddd",
            },
            dropdownStyle: {
                color: "#34ace0",
            },
        };
    },
    methods: {
        algorithmChanged(value: string) {
            this.$emit("algorithmChanged", value);
            this.algoDropdownVisible = false;
        },
        mazeGenerationAlgoSelected(value: string) {
            this.$emit("mazeGenerationAlgoSelected", value);
            this.mazeDropdownVisible = false;
        },
        sendUserHome() {
            this.$router.push("/");

            setTimeout(() => {
                window.location.reload();
            }, 0);
        },
    },
});
